import { render, staticRenderFns } from "./ElectronicsSwitchIcon.vue?vue&type=template&id=37d85a78&scoped=true&"
import script from "./ElectronicsSwitchIcon.vue?vue&type=script&lang=js&"
export * from "./ElectronicsSwitchIcon.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicsSwitchIcon.vue?vue&type=style&index=0&id=37d85a78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d85a78",
  null
  
)

export default component.exports